module.exports = __webpack_public_path__ + "img/intro1.d9fd40f3.png";